import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';

export default {
    data: function() {
        return {
            slidesPerView: 3,
            mobileSlidesPerView: 3,
            swiperOption: {},
            slidesPerGroupType: 'single',
            autoplay: true,
            playInterval: 8,
            speed: 1000,
            sliderOptions: {},
            agentItemSpace: 20,
            agentItemMobileSapce: 15,
            selectIndex: 0,
            loop: true,
            direction: 'horizontal',
            useSwiperApiParams: true
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        options({ enableNavigation, enablePagination, theme }) {
            //due to swiper will be broken when mode is virtual with loop and slider preview is not integer number, so we need to disable loop when agent length is more than 100 
            //theme broker-slider have this issue

            const isIntView = Number.isInteger(this.useSlidesPerView);
            let loop = false;
            let virtual = true;
            if (isIntView || this.agents.length < 100) {
                loop = (this.loop && this.agents.length > this.useSlidesPerView);
                virtual = (isIntView && this.agents.length > 50) ? true : false;
            }

            let options = {
                speed: this.speed,
                spaceBetween: this.useAgentItemSpace,
                slidesPerGroup:
                    this.slidesPerGroupType == 'full'
                        ? this.useSlidesPerView
                        : 1,
                slidesPerView: this.useSlidesPerView,
                loop,
                virtual
            };
            
            if (theme == 'layout2' && !this.isMobileSize) {
                options.direction = 'vertical';
                options.spaceBetween = 0;
                options.slidesPerGroup = 1;
            }
            if (theme == 'layout2' && this.isMobileSize) {
                options.speed = 1;
            }
            if (enableNavigation !== false) {
                options.navigation = {
                    closest: '.md-team',
                    prevEl: '.prev-el',
                    nextEl: '.next-el',
                    disabledClass: 'navigation-disabled'
                };
            }
            if (
                enablePagination !== false &&
                this.agents.length <= this.useSlidesPerView &&
                this.agents.length > 1
            ) {
                options.pagination = {
                    el: ' .swiper-pagination',
                    type: 'bullets',
                    clickable: true
                };
            }
            if (this.autoplay && this.agents.length > this.useSlidesPerView) {
                options.autoplay = {
                    delay: this.playInterval
                        ? parseInt(this.playInterval) * 1000
                        : 5000,
                    disableOnInteraction: false
                };
            } else {
                options.autoplay = false;
            }
            if (this.isMobileSize) {
                options = Object.assign(options, {
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                    slidesPerView: 1
                });
                if (theme == 'layout5' || theme == 'layout7' || theme == 'layout1') {
                    options.slidesPerView = this.useSlidesPerView;
                    options.spaceBetween = 10;
                }
                if (
                    theme == 'template8' ||
                    theme == 'layout2' ||
                    theme == 'layout8' || 
                    theme == 'layout9'
                ) {
                    options.autoHeight = true;
                }
                if (theme == 'layout4') {
                    options.autoHeight = true;
                    options.autoplay = false;
                    options.slidesPerView = 1.11;
                    options.spaceBetween = 10;
                    options.loop = false;
                }
            }
            options = Object.assign(options, this.swiperOption || {});
            options = fixSwiperOptions(options);
            return options;
        },
        enablePagination({ theme }) {
            return false;
        },
        enableNavigation({ useSlidesPerView }) {
            return this.agents.length > useSlidesPerView;
        },
        useSlidesPerView() {
            return this.isMobileSize
                ? this.mobileSlidesPerView
                : this.slidesPerView;
        },
        useAgentItemSpace() {
            return this.isMobileSize
                ? this.agentItemMobileSapce
                : this.agentItemSpace;
        },
        sliderShow() {
            return this.agents?.length > 0;
        }
    },
    methods: {
        changeSelectedIndex(index) {
            if (this.isMobileSize) {
                return;
            }
            this.selectIndex = index;
        }
    },
    components: {
        Swiper,
        Slide: SwiperSlide
    }
};
